var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { margin: "0 -15px" } }, [
    _c(
      "div",
      { staticClass: "distanceLabel", staticStyle: { padding: "10px 20px" } },
      [
        _c(
          "el-form",
          {
            ref: "editFormRef",
            attrs: {
              model: _vm.editForm,
              "label-position": "top",
              size: "small",
            },
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 10 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("navbar.ReasonForLimitedProblems"),
                          rules: [
                            {
                              required: true,
                              message: _vm.$t("GlobalSetObj.required"),
                              trigger: ["blur", "change"],
                            },
                          ],
                          prop: "problemTypeIds",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.pleaseChoose"
                              ),
                              clearable: "",
                              filterable: "",
                              multiple: "",
                            },
                            model: {
                              value: _vm.editForm.problemTypeIds,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "problemTypeIds", $$v)
                              },
                              expression: "editForm.problemTypeIds",
                            },
                          },
                          _vm._l(_vm.otherReasonList, function (item) {
                            return _c("el-option", {
                              key: item.problemId,
                              attrs: {
                                label: item.dictDescribe,
                                value: item.problemId,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("navbar.restrictionState"),
                          rules: [
                            {
                              required: true,
                              message: _vm.$t("GlobalSetObj.required"),
                              trigger: ["blur", "change"],
                            },
                          ],
                          prop: "stateList",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              clearable: "",
                              filterable: "",
                              multiple: "",
                            },
                            on: {
                              clear: function ($event) {
                                return _vm.clearSelect(
                                  "stateList",
                                  _vm.stateListOption
                                )
                              },
                              "remove-tag": function (value) {
                                return _vm.removeMerchant(
                                  value,
                                  "stateList",
                                  _vm.stateListOption
                                )
                              },
                            },
                            model: {
                              value: _vm.editForm.stateList,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "stateList", $$v)
                              },
                              expression: "editForm.stateList",
                            },
                          },
                          [
                            _c("el-option", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.stateListOption.length > 0,
                                  expression: "stateListOption.length > 0",
                                },
                              ],
                              attrs: {
                                label: _vm.$t("collectionCenter.tudo"),
                                value: -1,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.toggleSelectAll(
                                    "stateList",
                                    _vm.stateListOption
                                  )
                                },
                              },
                            }),
                            _vm._l(_vm.stateListOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  disabled: item.disabled,
                                  label: item.label,
                                  value: item.value,
                                },
                              })
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("navbar.restrictionSiteId"),
                          rules: [
                            {
                              required: true,
                              message: _vm.$t("GlobalSetObj.required"),
                              trigger: ["blur", "change"],
                            },
                          ],
                          prop: "siteIds",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              "remote-method": _vm.handleStateList,
                              clearable: "",
                              filterable: "",
                              multiple: "",
                              remote: "",
                              "reserve-keyword": "",
                            },
                            on: {
                              clear: function ($event) {
                                return _vm.clearSelect(
                                  "siteIds",
                                  _vm.siteListOption
                                )
                              },
                              "visible-change": _vm.openHandleStateList,
                              "remove-tag": function (value) {
                                return _vm.removeMerchant(
                                  value,
                                  "siteIds",
                                  _vm.siteListOption
                                )
                              },
                            },
                            model: {
                              value: _vm.editForm.siteIds,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "siteIds", $$v)
                              },
                              expression: "editForm.siteIds",
                            },
                          },
                          [
                            _c("el-option", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.siteListOption.length > 0,
                                  expression: "siteListOption.length > 0",
                                },
                              ],
                              attrs: {
                                label: _vm.$t("collectionCenter.tudo"),
                                value: -1,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.toggleSelectAll(
                                    "siteIds",
                                    _vm.siteListOption
                                  )
                                },
                              },
                            }),
                            _vm._l(_vm.siteListOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: {
                                  disabled: item.disabled,
                                  label: item.label,
                                  value: item.value,
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.selectSite(
                                      "siteIds",
                                      _vm.siteListOption
                                    )
                                  },
                                },
                              })
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("navbar.RestrictedAccounts"),
                          rules: [
                            {
                              required: true,
                              message: _vm.$t("GlobalSetObj.required"),
                              trigger: ["blur", "change"],
                            },
                          ],
                          prop: "userIds",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              "remote-method": _vm.getAllUserList,
                              clearable: "",
                              filterable: "",
                              multiple: "",
                              remote: "",
                              "reserve-keyword": "",
                            },
                            on: {
                              clear: function ($event) {
                                return _vm.clearSelect(
                                  "userIds",
                                  _vm.accountList
                                )
                              },
                              "visible-change": _vm.openUserList,
                              "remove-tag": function (value) {
                                return _vm.removeMerchant(
                                  value,
                                  "userIds",
                                  _vm.accountList
                                )
                              },
                            },
                            model: {
                              value: _vm.editForm.userIds,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "userIds", $$v)
                              },
                              expression: "editForm.userIds",
                            },
                          },
                          [
                            _c("el-option", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.accountList.length > 0,
                                  expression: "accountList.length > 0",
                                },
                              ],
                              attrs: {
                                label: _vm.$t("collectionCenter.tudo"),
                                value: -1,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.toggleSelectAll(
                                    "userIds",
                                    _vm.accountList
                                  )
                                },
                              },
                            }),
                            _vm._l(_vm.accountList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: {
                                  disabled: item.disabled,
                                  label: item.label,
                                  value: item.value,
                                },
                              })
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("GlobalSetObj.client"),
                          rules: [
                            {
                              required: true,
                              message: _vm.$t("GlobalSetObj.required"),
                              trigger: ["blur", "change"],
                            },
                          ],
                          prop: "customerIds",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              "remote-method": _vm.getCustomerPage,
                              clearable: "",
                              filterable: "",
                              multiple: "",
                              remote: "",
                              "reserve-keyword": "",
                            },
                            on: {
                              change: _vm.changeCustomer,
                              clear: function ($event) {
                                return _vm.clearSelect(
                                  "customerIds",
                                  _vm.customerOption
                                )
                              },
                              "visible-change": _vm.openCustomerPage,
                              "remove-tag": function (value) {
                                return _vm.removeMerchant(
                                  value,
                                  "customerIds",
                                  _vm.customerOption
                                )
                              },
                            },
                            model: {
                              value: _vm.editForm.customerIds,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "customerIds", $$v)
                              },
                              expression: "editForm.customerIds",
                            },
                          },
                          [
                            _c("el-option", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.customerOption.length > 0,
                                  expression: "customerOption.length > 0",
                                },
                              ],
                              attrs: {
                                label: _vm.$t("collectionCenter.tudo"),
                                value: -1,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.toggleSelectAll(
                                    "customerIds",
                                    _vm.customerOption
                                  )
                                },
                              },
                            }),
                            _vm._l(_vm.customerOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: {
                                  disabled: item.disabled,
                                  label: item.label,
                                  value: item.value,
                                },
                              })
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("collectionCenter.CommercialOwner"),
                          rules: [
                            {
                              required: true,
                              message: _vm.$t("GlobalSetObj.required"),
                              trigger: ["blur", "change"],
                            },
                          ],
                          prop: "merchantCodes",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              "remote-method": _vm.getMerchantList,
                              clearable: "",
                              filterable: "",
                              multiple: "",
                              remote: "",
                              "reserve-keyword": "",
                            },
                            on: {
                              clear: function ($event) {
                                return _vm.clearSelect(
                                  "merchantCodes",
                                  _vm.merchantOption
                                )
                              },
                              "visible-change": _vm.openMerchantList,
                              "remove-tag": function (value) {
                                return _vm.removeMerchant(
                                  value,
                                  "merchantCodes",
                                  _vm.merchantOption
                                )
                              },
                            },
                            model: {
                              value: _vm.editForm.merchantCodes,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "merchantCodes", $$v)
                              },
                              expression: "editForm.merchantCodes",
                            },
                          },
                          [
                            _c("el-option", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.merchantOption.length > 0,
                                  expression: "merchantOption.length > 0",
                                },
                              ],
                              attrs: {
                                label: _vm.$t("collectionCenter.tudo"),
                                value: -1,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.toggleSelectAll(
                                    "merchantCodes",
                                    _vm.merchantOption
                                  )
                                },
                              },
                            }),
                            _vm._l(_vm.merchantOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  disabled: item.disabled,
                                  label: item.label,
                                  value: item.value,
                                },
                              })
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("placeOrder.cargoType"),
                          rules: [
                            {
                              required: true,
                              message: _vm.$t("GlobalSetObj.required"),
                              trigger: ["blur", "change"],
                            },
                          ],
                          prop: "cargoType",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.editForm.cargoType,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "cargoType", $$v)
                              },
                              expression: "editForm.cargoType",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("GlobalSetObj.all"),
                                value: -1,
                              },
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("WorkCentreTable.normal"),
                                value: 0,
                              },
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("GlobalSetObj.big01"),
                                value: 1,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { display: "inline-block", width: "50%" },
                        attrs: {
                          label:
                            _vm.$t("navbar.ProblemRegistrationDistance") +
                            "(M)",
                          rules: [
                            {
                              required: true,
                              message: _vm.$t("GlobalSetObj.required"),
                              trigger: ["blur", "change"],
                            },
                          ],
                          prop: "mustDistance",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              clearable: "",
                              filterable: "",
                            },
                            on: { change: _vm.changeDistance },
                            model: {
                              value: _vm.editForm.mustDistance,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "mustDistance", $$v)
                              },
                              expression: "editForm.mustDistance",
                            },
                          },
                          [
                            _c("el-option", {
                              key: 1,
                              attrs: {
                                label: _vm.$t("GlobalSetObj.yes"),
                                value: 1,
                              },
                            }),
                            _c("el-option", {
                              key: 2,
                              attrs: {
                                label: _vm.$t("GlobalSetObj.No"),
                                value: 0,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.editForm.mustDistance === 1
                      ? _c(
                          "el-form-item",
                          {
                            staticStyle: {
                              display: "inline-block",
                              width: "50%",
                            },
                            attrs: {
                              rules: [
                                {
                                  required: true,
                                  validator: _vm.distanceRules,
                                  trigger: ["blur", "change"],
                                },
                              ],
                              label: "",
                              prop: "distance",
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                                clearable: "",
                              },
                              model: {
                                value: _vm.editForm.distance,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "distance", $$v)
                                },
                                expression: "editForm.distance",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("navbar.ForcePhoto"),
                          rules: [
                            {
                              required: true,
                              message: _vm.$t("GlobalSetObj.required"),
                              trigger: ["blur", "change"],
                            },
                          ],
                          prop: "mustPic",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              clearable: "",
                              filterable: "",
                            },
                            model: {
                              value: _vm.editForm.mustPic,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "mustPic", $$v)
                              },
                              expression: "editForm.mustPic",
                            },
                          },
                          [
                            _c("el-option", {
                              key: 1,
                              attrs: {
                                label: _vm.$t("GlobalSetObj.yes"),
                                value: 1,
                              },
                            }),
                            _c("el-option", {
                              key: 2,
                              attrs: {
                                label: _vm.$t("GlobalSetObj.No"),
                                value: 0,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.editForm.mustDistance === 1
                  ? _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("navbar.toleranceEnabled"),
                              rules: [
                                {
                                  required: true,
                                  message: _vm.$t("GlobalSetObj.required"),
                                  trigger: ["blur", "change"],
                                },
                              ],
                              prop: "toleranceEnabled",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseChoose"
                                  ),
                                  clearable: "",
                                  filterable: "",
                                },
                                on: { change: _vm.changeToleranceEnabled },
                                model: {
                                  value: _vm.editForm.toleranceEnabled,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editForm,
                                      "toleranceEnabled",
                                      $$v
                                    )
                                  },
                                  expression: "editForm.toleranceEnabled",
                                },
                              },
                              [
                                _c("el-option", {
                                  key: 1,
                                  attrs: {
                                    label: _vm.$t("GlobalSetObj.yes"),
                                    value: 1,
                                  },
                                }),
                                _c("el-option", {
                                  key: 0,
                                  attrs: {
                                    label: _vm.$t("GlobalSetObj.No"),
                                    value: 0,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.editForm.mustDistance === 1 &&
                _vm.editForm.toleranceEnabled === 1
                  ? _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("navbar.tolerancePercent"),
                              rules: [
                                {
                                  required: true,
                                  validator: _vm.tolerancePercentRules,
                                  trigger: ["blur", "change"],
                                },
                              ],
                              prop: "tolerancePercent",
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                                clearable: "",
                                maxlength: "3",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "suffix",
                                    fn: function () {
                                      return [_c("span", [_vm._v("%")])]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                302428916
                              ),
                              model: {
                                value: _vm.editForm.tolerancePercent,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "tolerancePercent",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "editForm.tolerancePercent",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticStyle: { "text-align": "right", padding: "10px 20px" } },
      [
        _c(
          "el-button",
          { attrs: { size: "small" }, on: { click: _vm.clickCancel } },
          [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
        ),
        _c(
          "el-button",
          {
            attrs: { size: "small", type: "primary" },
            on: { click: _vm.clickSubmit },
          },
          [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }